import React from "react";
import * as Glob from "../../Globale";
import { PageWrapper } from "../../components";

import { MainNav, INavConfig } from "../../components/DigitalProductAnalyser/Constants";
import "../../components/DigitalProductAnalyser/style.css";

export const AnalysersList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const session = (props.match.params as any).Sessione;

    return (
        <div className="page_dpa kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
            <PageWrapper Session={session}>
                <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-padding-0 ">
                    <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                        <div className="kt-portlet content">
                            <div className="kt-portlet__head">
                                <div className="kt-portlet__head-label">
                                    <span className="kt-portlet__head-icon ">
                                        <i className="fa fa-users" />
                                    </span>
                                    <h3 className="kt-portlet__head-label">Digital Product Analyser</h3>
                                </div>
                            </div>
                            <form className="kt-form login-form login-form--fit kt-form login-form--label-align-right">
                                <div className="kt-portlet__body content_dpa ">
                                    {MainNav.map((item: INavConfig) => (
                                        <div className="kt-iconbox">
                                            <div className="kt-iconbox__body">
                                                <div className="kt-iconbox__desc">
                                                    <h3 className="kt-iconbox__title">
                                                        <span className="kt-font-brand kt-margin-r-15">
                                                            <i className="fa fa-chevron-right" />
                                                        </span>
                                                        <a href={`${item.Href}/Sessione/${session}`} className="kt-link">
                                                            {item.Title}
                                                        </a>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/form/DigitalProductAnalyser/AnalysersList.tsx